import ReadMoreButton from "./ReadMoreButton";
import { useNavigate } from "react-router-dom";
import OptimizedImage from "./OptimizedImage";

export default function AboutSection() {
  const navigate = useNavigate();
  return (
    <section className="home-section">
      <div className="heading">
        <OptimizedImage
          src={require("../assets/images/about-icon.png")}
          className="icon"
          alt="Icona Chi sono"
          width={64}
          height={64}
          loading="lazy"
        />
        <div style={{ fontWeight: "bold", color: "#145444" }}>Chi sono</div>
      </div>
      <div className="divider" />
      <p className="paragraph">
        Mi chiamo Ilaria Stumpo e sono un’appassionata insegnante di yoga e
        coach del benessere, costantemente impegnata in un processo di continua
        crescita personale e professionale.
        <br />
        <br />
        Il mio primo incontro con lo yoga è avvenuto molti anni fa, durante un
        periodo per nulla sereno della mia adolescenza. È stato il primo seme
        piantato che è rimasto lì per un po’ in attesa di germogliare. Nel 2020
        mi è stata diagnosticata la fibromialgia, una malattia cronica
        dell’apparato muscoloscheletrico. È stato allora che la mia intuizione
        mi ha portato ad iniziare a praticare yoga ogni giorno e da lì non ho
        mai smesso. Lo yoga mi ha permesso di ridare fiducia ad un corpo fragile
        e dolorante, ma non solo: mi ha permesso di intraprendere un percorso di
        conoscenza e di scoperta di me stessa e della mia interiorità. Ad un
        certo punto mi sono accorta che la pratica non bastava più e che avevo
        bisogno di andare più a fondo...
      </p>
      <ReadMoreButton onClick={() => navigate("/chi-sono")} />
    </section>
  );
}
